import { useEffect, useState } from "react";

/**
 * Component to prevent FOUC (Flash of Unstyled Content) during hydration
 * Simplified version since we're handling this more directly
 */
export function HydrationBoundary({ children }: { children: React.ReactNode }) {
    const [isClientReady, setIsClientReady] = useState(false);

    useEffect(() => {
        // Asegurar que estamos en el cliente
        setIsClientReady(true);
    }, []);

    // En el servidor, renderizar normalmente
    // En el cliente, esperar a que esté listo
    if (typeof window === "undefined") {
        return <>{children}</>;
    }

    if (!isClientReady) {
        return <>{children}</>;
    }

    return <>{children}</>;
}
